import React, { useEffect, useState } from "react";
import {
  Button,
  Chip,
  DocumentsList,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import {
  addNewImmigrationsStart,
  getAllImmigrationsStart,
} from "../../../../../../redux/slices/immigration/immigrationSlice";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { getEmployeeByUiidStart } from "../../../../../../redux/slices/employee/employeeSlice";
import {
  BasisOfH1B,
  H1BStatus,
  WADocStatus,
} from "../../../../../../assets/data/enumData";
import { label } from "framer-motion/client";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
import axiosRequest from "../../../../../../redux/slices/universal/axiosService";
const HoneBTab = ({
  handleBackOrCancel,
  editData = null,
  immigrationsTableData,
}) => {
  const isEditMode = !!editData;
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
  } = useSelector((state) => state.employee);
  const { userData: loginUserData } = useLoginUser();
  const [attachmentModal, setAttachmentModal] = useState(false);
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const immigrationUiid =
    employeeDetails?.immigrations?.length > 0
      ? employeeDetails.immigrations[0]
      : "";
  const tableDataLCA =
    Array.isArray(immigrationsTableData?.data?.lca) &&
    immigrationsTableData.data.lca.length > 0
      ? immigrationsTableData.data.lca
      : [];
  const filterDatesActive = tableDataLCA.filter(
    (data) => new Date(data.endDate) > new Date(),
  );
  const lcaNumbersOptions = filterDatesActive.map((data) => ({
    label: data.number,
    value: data.number,
  }));

  const dispatch = useDispatch();
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        hOneBStatus: "",
        receiptNumber: "",
        processingType: 1,
        basisOfH1B: "",
        lcas: "",
        priority: "",
        recordStatus: "",
        expiryDate: "",
        attachment: [],
        comments: "",
      },
      {
        hOneBStatus: { type: "number", required: true },
        receiptNumber: { required: true },
        processingType: { type: "number", required: true },
        basisOfH1B: { type: "select", required: true },
        lcas: { type: "select", required: true },
        priority: { type: "select", required: true },
        recordStatus: { type: "select", required: true },
        expiryDate: { type: "date", required: true },
        attachment: { type: "file", required: true },
      },
    );
  const [lcaList, setLcaList] = useState([]);
  // If editData is provided, populate the form
  const handleCallLcaList = async (value) => {
    try {
      const filter = {
        employeeId: { type: "NONE", value: employeeProfileUiid },
        endDate: { type: "GTE", value: new Date() },
      };
      const reponse = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.LCA.GET_ALL,
        params: {
          coll: "LCA",
          fil: JSON.stringify(filter),
          ret: "uiid number endDate",
        },
      });
      if (reponse?.success) {
        const filterDatesActive = reponse?.data?.data?.filter(
          (data) => new Date(data.endDate) > new Date(),
        );
        const lcaNumbersOptions = filterDatesActive.map((data) => ({
          label: data.number,
          value: data.uiid,
        }));
        setLcaList(lcaNumbersOptions);
      } else {
        setLcaList([]);
      }
      console.log("reponse", reponse);
    } catch (error) {}
  };
  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const h1b = {
        // type: formData.processingType,
        status: formData.hOneBStatus,
        employeeId: employeeProfileUiid,
        expiryDate: formData.expiryDate,
        receiptNum: formData.receiptNumber,
        processType: formData.processingType,
        lcas: formData.lcas,
        priority: formData.priority,
        recordStatus: formData.recordStatus,
        comments: formData.comments,
        filedOn: new Date(),
        type: formData.basisOfH1B,
      };
      const cleanAttachments =
        Array.isArray(formData.attachment) && formData.attachment.length > 0
          ? formData.attachment.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];
      const submissionData = filterEmptyValues(h1b);
      if (cleanAttachments.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: employeeProfileUiid,
            entity: "h1bs",
            category: "h1bs",
            coll: "H1B",
            doc: cleanAttachments,
            onSuccess: async (fileData) => {
              const attachment = cleanAttachments.flatMap((data) =>
                fileData
                  .filter((file) => file.fileRefId === data.id)
                  .map((file) => file.key),
              );

              console.log("attachment", attachment);

              dispatch(
                addNewImmigrationsStart({
                  uiid: editData?.uiid || "",
                  coll: "H1B",
                  rsn: "h1b",
                  rsd: submissionData,
                  payload: editData?.uiid
                    ? [
                        {
                          type: "SET",
                          value: {
                            ...submissionData,
                            documents: attachment,
                          },
                        },
                      ]
                    : {
                        addedBy: loginUserUiid,
                        ...submissionData,
                        documents: attachment,
                      },
                  onSuccess: async (payload) => {
                    handleBackOrCancel();
                  },
                }),
              );
            },
          }),
        );
      } else {
      }
    } else {
      showToast("Please fill the required fields", "error");
    }
  };
  useEffect(() => {
    if (editData && isEditMode) {
      setFormData({
        hOneBStatus: editData.status || "",
        receiptNumber: editData.receiptNum || "",
        processingType: editData.processType || "Premium",
        lcas: editData.lcas || "",
        priority: editData.priority || "",
        recordStatus: editData.recordStatus || "",
        expiryDate: editData.expiryDate || "",
        attachment: editData.attachment || [],
        comments: editData.comments || "",
        basisOfH1B: editData.type || "",
      });
    }
    handleCallLcaList(employeeProfileUiid);
  }, [editData, setFormData]);
  const combineAttachments = (editData?.documents || []).map((data) => ({
    filePath: data,
    name: "H1B",
  }));
  return (
    <div className="pt-2 pr-2">
      <PageHeader
        Section={
          <div className="flex items-center gap-2">
            <div>
              <Button
                type="icon"
                variant="text"
                icon={"arrow_left_alt"}
                color="black"
                onClick={handleBackOrCancel}
              />
            </div>
            <PageTitle title={isEditMode ? "Edit H-1B" : "Add H-1B"} tag="p" />
          </div>
        }
      />
      {/* <div className="grid grid-cols-3 max-w-7xl gap-x-6 gap-y-4 mt-5"> */}
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4 mt-5">
        <FormFieldSet
          type="select"
          title={"H-1B Status"}
          placeholder="Select Status"
          value={formData.hOneBStatus}
          onChange={(value) => handleChange("hOneBStatus", value)}
          error={errors.hOneBStatus}
          options={H1BStatus}
        />
        <FormFieldSet
          type="text"
          title={"Receipt Number"}
          placeholder="Enter Receipt Number"
          value={formData.receiptNumber}
          onChange={(value) => handleChange("receiptNumber", value)}
          error={errors.receiptNumber}
        />

        <div className="hidden lg:block" />
        <FormFieldSet
          type="radio"
          title="Processing Type"
          options={[
            { label: "Premium", value: 1 },
            { label: "Normal", value: 2 },
          ]}
          value={formData.processingType}
          onChange={(event) =>
            handleChange("processingType", event.target.value)
          }
          name={"Processing Type"}
        />
        <FormFieldSet
          type="select"
          title={"Basis of H-1B"}
          placeholder="Select Basis"
          value={formData.basisOfH1B}
          onChange={(value) => handleChange("basisOfH1B", value)}
          error={errors.basisOfH1B}
          options={BasisOfH1B}
        />

        <FormFieldSet
          type="select"
          title={"LCA(S)"}
          placeholder="Select LCA"
          value={formData.lcas}
          onChange={(value) => handleChange("lcas", value)}
          error={errors.lcas}
          options={lcaList || []}
        />

        <FormFieldSet
          type="select"
          title={"Priority"}
          placeholder="Select Priority"
          value={formData.priority}
          onChange={(value) => handleChange("priority", value)}
          error={errors.priority}
          options={[
            { label: "High", value: 1 },
            { label: "Medium", value: 2 },
            { label: "Low", value: 3 },
          ]}
        />

        <FormFieldSet
          type="select"
          title={"Record Status"}
          placeholder="Select Status"
          value={formData.recordStatus}
          onChange={(value) => handleChange("recordStatus", value)}
          error={errors.recordStatus}
          options={WADocStatus}
        />
        <FormFieldSet
          type="datepicker"
          title={"Expiry Date"}
          placeholder="Select Expiry Date"
          value={formData.expiryDate}
          onChange={(value) => handleChange("expiryDate", value)}
          error={errors.expiryDate}
          showDropdown={false}
        />
        <FormFieldSet
          type="file"
          title={"Attachment"}
          placeholder="Choose File"
          value={formData.attachment}
          onChange={(value) => handleChange("attachment", value)}
          error={errors.attachment}
          multiple
        />
        {editData && (
          <div
            className=" flex rounded-md items-center cursour-pointer"
            onClick={() => setAttachmentModal(!attachmentModal)}
          >
            <Chip
              label={`Attachments:-${combineAttachments.length}`}
              icon={"docs"}
              iconPosition={"before"}
            />
          </div>
        )}
        <FormFieldSet
          type="textArea"
          title={"Comments"}
          placeholder="Enter Comments"
          value={formData.comments}
          onChange={(value) => handleChange("comments", value)}
          error={errors.comments}
        />
      </div>
      <div className="flex gap-2 justify-end mt-8">
        <Button
          title={"Cancel"}
          variant="outlined"
          onClick={handleBackOrCancel}
        />
        <Button
          // title={isEditMode ? "Update" : "Save & Proceed"}
          title={"Save & Proceed"}
          onClick={handleSave}
        />
      </div>
      <Modal
        isOpen={attachmentModal}
        onClose={() => setAttachmentModal(false)}
        // title="Attachment View"
        // width="max-w-5xl"
        width="max-w-2xl"
        title={"Document Details"}
      >
        {/* <div className="flex flex-col justify-center items-center gap-8">
              <h6>attachement Details</h6> */}
        <DocumentsList data={combineAttachments} />
        {/* <Button
                title={"Close"}
                onClick={() => setAttachmentModal(false)}
              /> */}
        {/* </div> */}
      </Modal>
    </div>
  );
};

export default HoneBTab;
